import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { FirestoreService } from 'src/services/firestore/firestore.service';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material';
import { AppDateAdapter } from 'src/shared/format-datepicker';
import Swal from 'sweetalert2';
import { MAT_DATE_LOCALE } from '@angular/material';

@Component({
  selector: 'app-informe-curso',
  templateUrl: './informe-curso.component.html',
  styleUrls: ['./informe-curso.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CL' }
  ]
})
export class InformeCursoComponent implements OnInit {

  /**
   * Variable que indica la pagina en la que te encuentras
   */
  p = 1;

  /**
   * Todas las evaluaciones
   */
  public evaluaciones = [];

  /**
   * Todas las observaciones
   */
  public observaciones = []
  /**
   * Dias a mostrar
   */
  public dias = [];

  /**
   * informe del alumno Seleccionado
   */
  public registros = [];
  /**
   * Opciones a mostrar en nivel
   */
  opcionesNivel = [
    {
      nombre: 'Kinder'
    },
    {
      nombre: 'Pre Kinder'
    },

    {
      nombre: 'Medio Mayor'
    },
    {
      nombre: 'Medio Menor'
    },
    {
      nombre: 'Sala Cuna Mayor'
    },
    {
      nombre: 'Sala Cuna Menor'
    },
  ];

  filteredNivel: Observable<any[]>;

  public informeCursoForm = new FormGroup({
    // nivel: new FormControl([], Validators.required),
    nivel: new FormControl([], Validators.required),
    fechaInicio: new FormControl('', Validators.required),
    fechaFin: new FormControl('', Validators.required),
    id: new FormControl('')
  });

  constructor(private firestoreService: FirestoreService, private dateAdapter: DateAdapter<any>) { }

  ngOnInit() {
    this.filtroNivel();
    this.getInformes();
    this.dateAdapter.setLocale('es');
  }

  /**
   * Segun lo que se ingrese en el input de nivel se actualizaran las opciones a mostrar
   */
  filtroNivel() {
    this.filteredNivel = this.informeCursoForm.controls.nivel.valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : value.nombre),
      map(name => name ? this._filterNivel(name) : this.opcionesNivel.slice())
    );
  }

  private _filterNivel(name: string): any[] {
    const filterValue = name.toLowerCase();
    return this.opcionesNivel.filter(option => option.nombre.toLowerCase().indexOf(filterValue) === 0);
  }

  imprimir() {
    const printContent = document.getElementById('informe');
    const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();
    // WindowPrt.close();
  }

  getInformes() {
    this.firestoreService.getAllData('Evaluaciones').subscribe(evaluacionesSnapshot => {
      this.evaluaciones = [];
      evaluacionesSnapshot.forEach((evaluacionesData: any) => {
        this.evaluaciones.push({
          id: evaluacionesData.payload.doc.id,
          data: evaluacionesData.payload.doc.data()
        });
      });
    });
  }

  informeNivel() {

    let fecha: Date = new Date(this.informeCursoForm.controls.fechaInicio.value);
    fecha.setDate(fecha.getDate() + 4);
    fecha.setHours(0);
    fecha.setMinutes(0);
    if (fecha.getTime() < this.informeCursoForm.controls.fechaFin.value.getTime()) {
      Swal.fire(
        'Atención!',
        'Solo se genera un informe de 5 dias.',
        'warning'
      );
    } else {
      fecha = new Date(this.informeCursoForm.controls.fechaFin.value);
    }
    this.getDates(this.informeCursoForm.controls.fechaInicio.value,
      fecha);
    this.registros = this.evaluaciones.filter(evaluacion => evaluacion.data.nivel === this.informeCursoForm.controls.nivel.value &&
      evaluacion.data.fecha >= this.informeCursoForm.controls.fechaInicio.value.getTime() &&
      evaluacion.data.fecha <= fecha.getTime());

    const group = this.groupBy(this.registros, registro => registro.data.alumno);
    this.registros = [];
    group.forEach((value: boolean, key: string) => {
      this.registros.push({ key, value });
    });

    this.registros.sort((a, b) => {
      return a.key.localeCompare(b.key);
    });
    this.firestoreService.getAllData('EvaluacionesNivel').subscribe(evaluacionesSnapshot => {
      this.observaciones = [];
      evaluacionesSnapshot.forEach((evaluacionesData: any) => {
        this.observaciones.push({
          id: evaluacionesData.payload.doc.id,
          data: evaluacionesData.payload.doc.data()
        });
      });

      this.observaciones = this.observaciones.filter(obs => {
        return obs.data.fecha >= this.informeCursoForm.controls.fechaInicio.value.getTime() &&
          obs.data.fecha <= fecha.getTime();
      });
    });
    this.observaciones.sort((a, b) => {
      if (a.data.fecha <= b.data.fecha) {
        return 1;
      } else {
        return -1;
      }
    });
  }

  groupBy(list, keyGetter) {
    const map = new Map();
    list.forEach((item) => {
      const key = keyGetter(item);
      const collection = map.get(key);
      if (!collection) {
        map.set(key, [item]);
      } else {
        collection.push(item);
      }
    });
    return map;
  }

  limpiar() {
    this.informeCursoForm.reset();
    this.registros = [];
    this.observaciones = [];
    this.filtroNivel();
  }

  getDates(startDate: Date, stopDate: Date) {
    this.dias = [];
    let currentDate = new Date(startDate);
    while (currentDate <= stopDate) {
      this.dias.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
  }

  validarDato(item, dia) {
    const list: any[] = item.value;
    let rpta = '-';
    list.forEach(element => {
      if (element.data.fecha === dia.getTime() ) {
        rpta = element.data.concepto;
      }
    });
    return rpta;
  }
}
